module.exports = __webpack_public_path__ + "img/icon-itel.c0112ebd.png";